/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Donation_CompleteInputs */

const en_donation_complete = /** @type {(inputs: Donation_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donated`)
};

const ar_donation_complete = /** @type {(inputs: Donation_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم التبرع`)
};

const de_donation_complete = /** @type {(inputs: Donation_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gespendet`)
};

const es_donation_complete = /** @type {(inputs: Donation_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donado`)
};

const fr_donation_complete = /** @type {(inputs: Donation_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don effectué`)
};

const it_donation_complete = /** @type {(inputs: Donation_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donato`)
};

const ja_donation_complete = /** @type {(inputs: Donation_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寄付済み`)
};

const ko_donation_complete = /** @type {(inputs: Donation_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기부 완료`)
};

const pt_br_donation_complete = /** @type {(inputs: Donation_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doado`)
};

const ru_donation_complete = /** @type {(inputs: Donation_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожертвовано`)
};

const th_donation_complete = /** @type {(inputs: Donation_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บริจาคแล้ว`)
};

const tr_donation_complete = /** @type {(inputs: Donation_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağış Yapıldı`)
};

const zh_cn_donation_complete = /** @type {(inputs: Donation_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已完成捐赠`)
};

const zh_tw_donation_complete = /** @type {(inputs: Donation_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已完成捐贈`)
};

/**
* | output |
* | --- |
* | "Donated" |
*
* @param {Donation_CompleteInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const donation_complete = /** @type {((inputs?: Donation_CompleteInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Donation_CompleteInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_donation_complete(inputs)
	if (locale === "ar") return ar_donation_complete(inputs)
	if (locale === "de") return de_donation_complete(inputs)
	if (locale === "es") return es_donation_complete(inputs)
	if (locale === "fr") return fr_donation_complete(inputs)
	if (locale === "it") return it_donation_complete(inputs)
	if (locale === "ja") return ja_donation_complete(inputs)
	if (locale === "ko") return ko_donation_complete(inputs)
	if (locale === "pt_br") return pt_br_donation_complete(inputs)
	if (locale === "ru") return ru_donation_complete(inputs)
	if (locale === "th") return th_donation_complete(inputs)
	if (locale === "tr") return tr_donation_complete(inputs)
	if (locale === "zh_cn") return zh_cn_donation_complete(inputs)
	return zh_tw_donation_complete(inputs)
});